import { API_URL } from "../constants";
import { getHeaders } from "../utils";

export const getListings = async () => {
  const response = await fetch(`${API_URL}/api/listings`, {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const getPMListings = async () => {
  const response = await fetch(`${API_URL}/api/property-manager/listings`, {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const getListingsReferral = async (referralCode) => {
  const response = await fetch(
    `${API_URL}/api/listings?referralCode=${referralCode}`,
    {
      method: "GET",
      //headers: getHeaders(),
    }
  );
  return response.json();
};

export const getListing = async (listingId) => {
  const response = await fetch(`${API_URL}/api/listings/${listingId}`, {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const addListing = async (payload) => {
  const response = await fetch(`${API_URL}/api/listings`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: getHeaders(),
  });
  return response.json();
};

export const updateListing = async (payload) => {
  const response = await fetch(`${API_URL}/api/listings/${payload.id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: getHeaders(),
  });
  return response.json();
};

export const getReferral = async (listingId) => {
  const response = await fetch(
    `${API_URL}/api/listings/${listingId}/referral-code`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const createReferral = async (payload) => {
  const response = await fetch(
    `${API_URL}/api/listings/${payload.id}/referral-code`,
    {
      method: "POST",
      body: JSON.stringify(payload),
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const createListingApplication = async (listingId, payload) => {
  const response = await fetch(
    `${API_URL}/api/listings/${listingId}/applications`,
    {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.json();
};
